import React from "react";

import TableMultiValueField from "./TableMultiValueField";
import { SET_BY_MARGIN_ENUMS } from "../../../system/globalEnums";
import { getGroupDisplayText } from "../../utilities/tradeInMarginUtility";

const TableCustomAppliesToField = ({ row, groupArray = [], groupType }) => {
  const categoryText =
    groupType === SET_BY_MARGIN_ENUMS.PRODUCT.value
      ? "Products"
      : groupType === SET_BY_MARGIN_ENUMS.CATEGORY.value
      ? "Categories"
      : groupType === SET_BY_MARGIN_ENUMS.TYPE.value
      ? "Types"
      : "Sub Categories";

  const isSingleLongName =
    groupArray.length === 1 && groupArray[0]?.categoryName?.length > 30;

  return (
    <TableMultiValueField
      label={categoryText}
      anchorId={`tool-${row.id}`}
      forceTooltip={isSingleLongName}
      valueClassName="applies-to-category text-truncate"
      values={groupArray.map((categoryOrType) =>
        getGroupDisplayText(categoryOrType, groupType)
      )}
    />
  );
};

export default TableCustomAppliesToField;
